// extracted by mini-css-extract-plugin
export default {"colorPickerContainer":"style_colorPickerContainer__U5iL-","flexGap":"style_flexGap__RHAHw"};